export default {
  "--light-bg": "#EEF0F5",
  "--light-bg-dark-shadow": "#C6CEDA",
  "--light-bg-light-shadow": "#E6E9EF",
  "--dark-bg": "#292E35",
  "--dark-bg-dark-shadow": "#21252a",
  "--dark-bg-light-shadow": "#313740",
  "--primary": "#596DE4",
  "--primary-dark": "#4526f9",
  "--primary-light": "#c7befd",
};
